import { createApp } from 'vue';
import GeneralLinkBlock from "multisite/components/cmsContentBlocks/generalLink.vue"
import store from 'shared/store';

const elements = document.querySelectorAll('[data-feature="FeatureColumnBlock"]');
if (elements.length) {
	elements.forEach((element, i) => {
		const app = createApp({
			name: `FeatureColumnBlockApp${i}`,
		});
		app.component('general-link-block', GeneralLinkBlock);
		app.use(store);
		app.mount(element);
	});
}
